import { render } from "./RecentRow.vue?vue&type=template&id=9dd975d2&scoped=true&ts=true"
import script from "./RecentRow.vue?vue&type=script&lang=ts"
export * from "./RecentRow.vue?vue&type=script&lang=ts"

import "./RecentRow.vue?vue&type=style&index=0&id=9dd975d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd975d2"]])

export default __exports__